import reactIntroduction from "./chapters/react-introduction";
import nodeJS from "./chapters/node-js";
import createReactApp from "./chapters/create-react-app";
import reactClassComponents from "./chapters/react-class-components";
import reactStructure from "./chapters/react-structure";
import tmdbAPI from "./chapters/tmdb-api";
import reactFetch from "./chapters/react-fetching-data";
import appStructure from "./chapters/app-structure";
import appMovies from "./chapters/app-movies";
import appMoviesStyles from "./chapters/app-movies-styles";
import appNavigation from "./chapters/app-navigation";
import linkNavigationMovieList from "./chapters/link-navigation-movie-list";
import moviePagesNavigation from "./chapters/movie-pages-navigation";
import aMoviePage from "./chapters/a-movie-page";
import localStorage from "./chapters/local-storage";

const book = {
  chapters: [
    {
      id: 0,
      title: "React Introduction",
      content: reactIntroduction,
      block: 0,
      position: 0
    },
    {
      id: 1,
      title: "Class Components",
      content: reactClassComponents,
      block: 0,
      position: 0
    },
    {
      id: 2,
      title: "React Application Structure",
      content: reactStructure,
      block: 0,
      position: 0
    },
    {
      id: 3,
      title: "Installing Node",
      content: nodeJS,
      block: 0,
      position: 0
    },
    {
      id: 4,
      title: "Create React App",
      content: createReactApp,
      block: 0,
      position: 0
    },
    {
      id: 5,
      title: "The Movie DB API",
      content: tmdbAPI,
      block: 0,
      position: 0
    },
    {
      id: 6,
      title: "Lifecycle Methods and Data Fetching",
      content: reactFetch,
      block: 0,
      position: 0
    },
    {
      id: 7,
      title: "Sweet Pumpkins App Structure",
      content: appStructure,
      block: 0,
      position: 0
    },
    {
      id: 8,
      title: "Movies",
      content: appMovies,
      block: 0,
      position: 0
    },
    {
      id: 9,
      title: "Styling Movies",
      content: appMoviesStyles,
      block: 0,
      position: 0
    },
    {
      id: 10,
      title: "App Navigation",
      content: appNavigation,
      block: 0,
      position: 0
    },
    {
      id: 11,
      title: "Linking Navigation with MovieList",
      content: linkNavigationMovieList,
      block: 0,
      position: 0
    },
    {
      id: 12,
      title: "Movies Pagination",
      content: moviePagesNavigation,
      block: 0,
      position: 0
    },
    {
      id: 13,
      title: "A Movie Page",
      content: aMoviePage,
      block: 0,
      position: 0
    },
    {
      id: 14,
      title: "Persisting Data in Local Storage",
      content: localStorage,
      block: 0,
      position: 0
    }
  ]
};

export default book;



// WEBPACK FOOTER //
// ./src/book/bookContent.js